<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-items v-if="project">
      <n-input title="Способ измерения перемещений сваи (отказомером, линейкой и др.)" v-bind="$form.input('p3.1')" :text="!editable" />
      <div>Примечание. На данной странице журнала приводят схему фактического расположения точек испытаний, а также ближайших инженерно-геологических выработок и точек зондирования</div>
      <n-input title="В журнале пронумеровано страниц" v-bind="$form.input('p3.2')" :text="!editable" />
      <n-input title="заполнено страниц" v-bind="$form.input('p3.3')" :text="!editable" />
      <n-input title="Начальник полевого подразделения (фамилия, инициалы)" v-bind="$form.input('p3.4')" :text="!editable" />
      <n-input title="Наблюдатели" v-bind="$form.input('p3.5')" :text="!editable" />
      <n-input title="Представитель организации, забивающей сваи" v-bind="$form.input('p3.6')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
